import * as ContextMenu from '@studio/design-system/context-menu';
import { χref } from '@studio/react-utils/hooks';
import { dequal } from 'dequal/lite';
import type { ReactElement } from 'react';
import { memo, useRef } from 'react';
import { Menu } from './menu.jsx';
import type { Props } from './types.js';
import type { Behavior } from '#~/common/card/index.js';
import { Card } from '#~/video/image/preset/components/card/index.js';

/** @internal */
const Inner = ({ handler, preset, ...props }: Props): ReactElement => {
  const cardRef = useRef<Behavior>(null);

  const menuHandler = {
    onRefresh(): void {
      handler.onRefresh(preset.id);
    },

    onRemove(): void {
      handler.onRemove(preset.id);
    },

    onRename(): void {
      window.setTimeout(() => {
        χref(cardRef)?.setEditing(true);
      }, 250);
    }
  };

  return (
    <ContextMenu.Root>
      <ContextMenu.Trigger>
        <Card handler={handler} preset={preset} ref={cardRef} {...props} />
      </ContextMenu.Trigger>

      <Menu handler={menuHandler} />
    </ContextMenu.Root>
  );
};

/** Image settings `<Preset>` component. */
export const Preset = memo(Inner, dequal);
